import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ConditionService } from "src/app/corporate/core/service/condition.service";
import { Condition } from "src/app/corporate/core/model/condition";

@Component({
  selector: "app-form-edit-condition",
  templateUrl: "./form-edit-condition.component.html",
  styleUrls: ["./form-edit-condition.component.scss"],
})
export class FormEditConditionComponent implements OnInit {
  @Input() conditionId;

  requestId: number;

  condition: Condition;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _conditionService: ConditionService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      libelle: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getConditionById(this.conditionId);
  }

  getConditionById(conditionid) {
    this._conditionService.getConditionById(conditionid).subscribe(
      (data) => {
        this.condition = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(): void {
    this.spinner.show();
    this._conditionService
      .putCondition(this.condition)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
